import { useState } from "react";

import { Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./financial.css";

// Importe dos componetes
import AccountReceivable from "./Components/AccountReceivable/account_receivable";
import PaymentValues from "./Components/PaymentValues/payment_values";
import CouponDiscount from "./Components/CouponDiscount/coupon_discount";
import { useTheme } from "../../Provider/Theme/themeContext";

export default function Financial({ idClient }) {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const [tabSelected, setTabSelected] = useState("list-account-receivable");

    return (
        <div className="financial-wrapper">
            <div
                style={{
                    borderBottom:
                        theme === "dark"
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                }}
            >
                <Tabs
                    activeKey={tabSelected}
                    onSelect={(k) => setTabSelected(k)}
                    id="tab-account-receivable"
                    style={{ borderBottom: "none" }}
                >
                    <Tab
                        eventKey="list-account-receivable"
                        title={t("financial.accounts-receivable.tab.title")}
                    />
                    <Tab
                        eventKey="prices"
                        title={t("financial.prices.tab.title")}
                    />
                    <Tab
                        eventKey="coupon-discount"
                        title={t("financial.coupon-discount.tab.title")}
                    />
                </Tabs>
            </div>
            {tabSelected === "list-account-receivable" && (
                <div className="financial-content-wrapper">
                    <AccountReceivable idClient={idClient} />
                </div>
            )}
            {tabSelected === "prices" && (
                <div className="financial-content-wrapper">
                    <PaymentValues idClient={idClient} />
                </div>
            )}
            {tabSelected === "coupon-discount" && (
                <div className="financial-content-wrapper">
                    <CouponDiscount idClient={idClient} />
                </div>
            )}
        </div>
    );
}
